import { useContext, useEffect } from 'react';
import L from 'leaflet';
import { MapContext } from './map-ctx';
import { Wgs84Coordinates } from '../../models';

interface PolygonProps {
  points: Wgs84Coordinates[];
  id?: string;
  options?: L.PathOptions;
}

export function Polygon({ id, points, options }: PolygonProps) {
  const { map } = useContext(MapContext);

  useEffect(() => {
    const mapRef = map.current?.ref; // L.Map instance
    if (!mapRef || !points || points.length < 3) {
      // A polygon needs at least 3 points
      return;
    }

    // Filter for valid WGS84 points
    const validWgs84Points = points.filter(
      (p) => p && typeof p.lat === 'number' && typeof p.lon === 'number'
    );

    if (validWgs84Points.length < 3) {
      console.warn(
        'Polygon component: Not enough valid points to draw a polygon.'
      );
      return;
    }

    const latLngs = validWgs84Points.map((p) =>
      L.latLng(p.lat ?? 0, p.lon ?? 0)
    );

    const leafletPolygon = L.polygon(latLngs, options);

    if (id) {
      // Optionally, attach the id to the layer instance for later retrieval if needed
      (leafletPolygon as any).customId = id;
    }

    leafletPolygon.addTo(mapRef);

    return () => {
      if (mapRef && mapRef.hasLayer(leafletPolygon)) {
        leafletPolygon.remove();
      }
    };
  }, [map, points, options, id]);

  return null;
}
